var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.58,83.47V60.11a11.37,11.37,0,0,0-11.34-11.34H103.9A11.37,11.37,0,0,0,92.56,60.11V83.47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 109.57,
    cy: 28.02,
    r: 11.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.58,201.85V178.49a11.37,11.37,0,0,0-11.34-11.34H103.9a11.37,11.37,0,0,0-11.34,11.34v23.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 109.57,
    cy: 146.4,
    r: 11.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71,152.18V128.82a11.38,11.38,0,0,0-11.34-11.34H48.34A11.38,11.38,0,0,0,37,128.82v23.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 54.01,
    cy: 96.73,
    r: 11.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.91,152.18V128.82a11.38,11.38,0,0,0-11.34-11.34H159.23a11.37,11.37,0,0,0-11.33,11.34v23.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 164.9,
    cy: 96.73,
    r: 11.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.31,88.23A57.92,57.92,0,0,1,91.43,66.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.79,176.92A58,58,0,0,1,60.5,152.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.64,152.18c-7.5,12-17.89,21-31.81,25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.8,66.35a57.92,57.92,0,0,1,30,21.88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/COMMUNITY.9edae489561b06274845b70b39de32c2.svg";
export { ForwardRef as ReactComponent };